export const MAXIMIZE_LIFETIME_BENEFITS = 0;
export const MAXIMIZE_NET_WORTH = 1;
